export const em = (e: any): string => e?.data?.statusCode !== 500 ? e?.data?.message ?? 'Неизвестная ошибка' : 'Неизвестная ошибка';
